import { ApiConstant, SystemConstant } from "@/const";
import GlobalApi from "./config/api.config";

export const uploadAttachment = async (file: File, type: string = SystemConstant.ATTACHMENT_TYPES.image) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("type", type);
  const response = await GlobalApi.toCamel().post<any>(ApiConstant.POST_ATTACHMENT_UPLOAD, formData, {
    headers: ApiConstant.HEADER_DEFAULT_UPLOAD_FILE,
  });
  if (response.ok && response?.data?.data?.uri) return response.data.data.uri;
  throw response;
};
